'use client'
import clsx from 'clsx'

// import { HeaderInterface } from './Header.types'
import { mainMenu } from '@/fixtures/menu'

import HeaderProvider from './context/HeaderProvider'

import HeaderMain from './Header'
import PreHeader from './PreHeader'
import styles from './Header.module.scss'

const Header = ({ isHomepage }: { isHomepage?: boolean }) => {
  return (
    <HeaderProvider
      menu={mainMenu}
      isHomepage={isHomepage}
    >
      <header className={clsx(styles.headerWrapper)}>
        <PreHeader />
        <HeaderMain />
      </header>
    </HeaderProvider>
  )
}

export default Header
